import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { Box, FormControl, MenuItem, Select } from "@material-ui/core";
import { options } from "../../defaultValues";
import { useStyles } from "./styles";

function StatusFilter({
  classes: { formControl, select, statusFilter },
  filter,
  handleChange,
}) {
  return (
    <Box className={statusFilter}>
      <FormControl size="small" className={formControl} fullWidth>
        <Select
          labelId="status-simple-select-label"
          id="status-simple-select"
          name="status"
          value={[filter.status]}
          label="Status"
          onChange={handleChange}
          className={select}
          disableUnderline={true}
        >
          {options.status.map((item) => {
            return <MenuItem value={item.value} key={item.value}>{item.title}</MenuItem>;
          })}
        </Select>
      </FormControl>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(StatusFilter);
